// extracted by mini-css-extract-plugin
export var lg = "_3c-4";
export var md = "_3c-3";
export var sm = "_3c-2";
export var xs = "_3c-1";
export var xxs = "_3c-0";